import _debounce from 'lodash/debounce';
import template from './absence-employees.html';

class SummariesAbsenceEmployeesComponent {
  constructor(
    $log,
    moment,
    SummaryService
  ) {
    'ngInject';
    this.$log = $log;
    this.moment = moment;
    this.SummaryService = SummaryService;

    this.dataTable = {};
    this.loadPageCallbackWithDebounce = {};
    this.filterState = {
      dateFrom: this.moment().subtract(7, 'days').toDate(),
      dateTo: this.moment().toDate(),
      selectedEmployee: 'ALL'
    };
    this.dateFrom = this.filterState.dateFrom;
    this.dateTo = this.filterState.dateTo;
  }

  $onInit() {
    this.loadTotalEmployeeAbsence();
  }

  $onChanges(changes) {
    if (changes.me) {
      this.me = {...this.me};
    }

    if (changes.employees) {
      this.employees = Object.assign([], this.employees);
    }
  }

  getLoadResultsCallback(loadPageCallback) {
    this.loadPageCallbackWithDebounce = _debounce(loadPageCallback, 1000);
  }

  paginatorCallback(page = 1, pageSize = 0) {
    let offset = (page - 1) * pageSize;
    if (angular.isUndefined(offset)) {
      offset = 0;
    }

    const filterParams = this.getFilterParams();
    return this.SummaryService.getEmployeesAbsences({
      ...filterParams,
      offset,
      limit: pageSize
    }).then(result => ({
      results: result.summary,
      totalResultCount: result.total
    }));
  }

  setFilter(filterForm) {
    if (!filterForm.$valid) {
      return false;
    }

    this.dateFrom = this.filterState.dateFrom;
    this.dateTo = this.filterState.dateTo;
    this.dataTable.mdtPaginationHelper.getFirstPage();
    this.loadTotalEmployeeAbsence();
  }

  getFilterParams() {
    const filterParams = {
      dateFrom: this.moment(this.filterState.dateFrom).format('YYYY-MM-DD'),
      dateTo: this.moment(this.filterState.dateTo).format('YYYY-MM-DD')
    };
    if (this.filterState.selectedEmployee !== 'ALL') {
      filterParams.employeeIds = this.filterState.selectedEmployee;
    }

    return filterParams;
  }

  loadTotalEmployeeAbsence() {
    const filterParams = this.getFilterParams();
    return this.SummaryService.getTotalEmployeesAbsence({
      ...filterParams
    }).then(result => {
      this.total = [result];
    });
  }
}

export const AbsenceEmployees = {
  bindings: {
    me: '<',
    employees: '<'
  },
  template,
  controller: SummariesAbsenceEmployeesComponent
};
